"use client";

import type { ReactNode } from "react";
import { usePathname } from "next/navigation";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { useContentPadding } from "@/context/LayoutContext";
import { TutorialSystem } from "@/components/onboarding/TutorialSystem";

interface AppChromeProps {
  readonly children: ReactNode;
}

const HIDDEN_CHROME_PREFIXES = ["/editor", "/editor/one-click", "/login", "/cadastro", "/recuperar-senha"];

const shouldHideChrome = (pathname: string | null): boolean => {
  if (!pathname) {
    return false;
  }
  return HIDDEN_CHROME_PREFIXES.some((prefix) => pathname.startsWith(prefix));
};

export function AppChrome({ children }: AppChromeProps) {
  const pathname = usePathname();
  const hideChrome = shouldHideChrome(pathname);
  const { left: paddingLeft, right: paddingRight } = useContentPadding();

  if (hideChrome) {
    return (
      <main id="conteudo-principal" className="min-h-screen bg-[#0f011b]">
        {children}
      </main>
    );
  }

  return (
    <>
      <Header />
      <TutorialSystem />
      <main 
        id="conteudo-principal" 
        className="pt-24 lg:pt-28"
        style={{ 
          paddingLeft: `${paddingLeft}px`, 
          paddingRight: `${paddingRight}px` 
        }}
      >
        {children}
      </main>
      <Footer />
    </>
  );
}
